import { Box } from '@mui/material';
import React from 'react';
type LabelValueProps = {
  label: React.ReactNode;
  value?: React.ReactNode | number;
};

export const LabelValue: React.FC<LabelValueProps> = props => {
  return (
    <Box display={'flex'} alignItems={'center'} fontSize={14}>
      <Box marginRight={1} color={'#224295'}>
        {props.label}:
      </Box>
      <Box>{props.value}</Box>
    </Box>
  );
};
